import React from "react";

export const DashboardStatsSection = ({ firstName }) => {
  return (
    <header
      className="w-full text-white"
      style={{
        background: `linear-gradient(to right, var(--brand-medium-blue), var(--brand-dark-blue))`,
      }}
    >
      <div className="mx-auto max-w-7xl px-4 pb-16 pt-8 sm:px-6 sm:pb-20 sm:pt-12">
        <h1 className="text-2xl font-normal sm:text-3xl md:text-4xl">
          Welcome Back{firstName ? `, ${firstName}!` : ""}
        </h1>
      </div>
    </header>
  );
};
